import React from 'react';
import { ExternalLink } from 'lucide-react';

export const MY_AGED_CARE_APPLY_URL = 'https://www.myagedcare.gov.au/assessment/apply-online';
const MY_AGED_CARE_PORTAL_URL = 'https://www.myagedcare.gov.au/';

interface MyAgedCareApplyLinkProps {
    status?: 'yes' | 'no' | 'in_progress';
    className?: string;
}

/**
 * Compact secondary action — opens My Aged Care (apply or portal) in a new tab.
 */
const MyAgedCareApplyLink = ({ status = 'no', className = '' }: MyAgedCareApplyLinkProps) => {
    const isInProgress = status === 'in_progress';
    const url = isInProgress ? MY_AGED_CARE_PORTAL_URL : MY_AGED_CARE_APPLY_URL;
    const label = isInProgress ? 'Check on My Aged Care' : 'Apply via My Aged Care';

    return (
        <button
            type="button"
            onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
            className={`inline-flex shrink-0 items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 shadow-sm transition-colors hover:border-[#5A2A82]/25 hover:bg-gray-50 hover:text-[#5A2A82] ${className}`}
            aria-label={`${label} (opens My Aged Care in a new tab)`}
        >
            <span>{label}</span>
            <ExternalLink size={12} className="shrink-0 opacity-60" aria-hidden />
        </button>
    );
};

export default MyAgedCareApplyLink;
